export default "__VITE_ASSET__49e0f885__"